import { render, staticRenderFns } from "./SocialPopup.vue?vue&type=template&id=3270d6a0&scoped=true"
import script from "./SocialPopup.vue?vue&type=script&lang=js"
export * from "./SocialPopup.vue?vue&type=script&lang=js"
import style0 from "./SocialPopup.vue?vue&type=style&index=0&id=3270d6a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3270d6a0",
  null
  
)

export default component.exports